<template>
  <div id="mainCommonDataWrapper">
    <div id="chooseEmployee">
      <a-row type="flex">
        <a-col>
          <h2>{{ $t("employee") }}</h2>
        </a-col>
        <a-col
          v-if="currentUserIdForEdit !== '' && +currentUserIdForEdit >= 0"
          style="flex: 1; margin-left: 15px"
        >
          <a-select
            style="width: 100%; text-align: center"
            showSearch
            @search="searchUser"
            @change="changeCurrentUserIdForEdit"
            :filter-option="false"
            :default-value="
              userInfo[currentUserIdForEdit].LAST_NAME +
              ' ' +
              userInfo[currentUserIdForEdit].NAME
            "
          >
            <a-select-option
              v-for="employee in filterUserList"
              :key="employee.ID"
              :value="employee.ID"
            >
              <a-avatar
                v-if="employee.PERSONAL_PHOTO"
                style="width: 24px; height: 24px; margin-bottom: 3px"
                :src="employee.PERSONAL_PHOTO"
              />
              <a-avatar
                v-else
                style="
                  width: 25px;
                  height: 25px;
                  color: #f56a00;
                  background-color: #fde3cf;
                  margin-bottom: 3px;
                  line-height: 24px;
                  font-weight: 500;
                "
                >{{ employee.NAME ? employee.NAME[0] : "?" }}</a-avatar
              >
              {{ `${employee.LAST_NAME} ${employee.NAME}` }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </div>

    <a-row gutter="16" v-if="userInfo[currentUserIdForEdit]">
      <a-col
        :span="
          userInfo.length != 0 &&
          currentUserObj != '' &&
          !(
            isAdmin ||
            userAccess.length != 0 ||
            currentUserObj.ID == userInfo[currentUserIdForEdit].ID
          )
            ? 24
            : 12
        "
      >
        <div id="commonData">
          <a-descriptions
            bordered
            :title="$t('Dane podstawowe')"
            size="small"
            :column="1"
          >
            <a-descriptions-item :label="$t('NAME')">
              <a-row type="flex" v-if="!visibleImie">
                <a-col style="flex: 1; padding-right: 5px">{{
                  userInfo[currentUserIdForEdit].NAME
                }}</a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleImie = true;
                  NAME = userInfo[currentUserIdForEdit].NAME;
                  " />
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleImie">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="userInfo[currentUserIdForEdit].NAME"
                    v-model="NAME"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleImie = false;
                      editBxData('NAME', NAME);
                    "
                  />
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('LAST_NAME')">
              <a-row type="flex" v-if="!visibleNazw">
                <a-col style="flex: 1; padding-right: 5px">{{
                  userInfo[currentUserIdForEdit].LAST_NAME
                }}</a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleNazw = true;
                  LAST_NAME = userInfo[currentUserIdForEdit].LAST_NAME;
                  " />
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleNazw">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="userInfo[currentUserIdForEdit].LAST_NAME"
                    v-model="LAST_NAME"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleNazw = false;
                      editBxData('LAST_NAME', LAST_NAME);
                    "
                  />
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('NazwaFirmy')">
              {{
                entityUser &&
                entityUser.NazwaFirmy &&
                entityUser.NazwaFirmy !== "undefined"
                  ? entityUser.company.TITLE
                  : ""
              }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('UF_DEPARTMENT')">
              <a-row type="flex" v-if="!visibleDepartment">
                <a-col style="flex: 1; padding-right: 5px">
                  <div
                    v-for="(iteration, index) in userInfo[currentUserIdForEdit]
                      .UF_DEPARTMENT"
                    :key="iteration"
                    style="margin: 2px"
                  >
                    {{ getDepartmentInfo(index, "NAME") }}
                  </div>
                </a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleDepartment = true;
                  UF_DEPARTMENT =
                    userInfo[currentUserIdForEdit].UF_DEPARTMENT;
                  " />
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleDepartment">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-select
                    mode="tags"
                    :default-value="
                      userInfo[currentUserIdForEdit].UF_DEPARTMENT.map(
                        (el, index) => getDepartmentInfo(index, 'NAME')
                      )
                    "
                    @change="handleChangeDepartments"
                  >
                    <a-select-option
                      v-for="item in departments"
                      :key="item.ID"
                      :value="item.NAME"
                      >{{ item.NAME }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleDepartment = false;
                      editBxData('UF_DEPARTMENT', UF_DEPARTMENT);
                    "
                  />
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('WORK_POSITION')">
              <a-row type="flex" v-if="!visiblePosition">
                <a-col style="flex: 1; padding-right: 5px">{{
                  userInfo[currentUserIdForEdit].WORK_POSITION
                }}</a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visiblePosition = true;
                  WORK_POSITION =
                    userInfo[currentUserIdForEdit].WORK_POSITION;
                  " />
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visiblePosition">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="
                      userInfo[currentUserIdForEdit].WORK_POSITION
                    "
                    v-model="WORK_POSITION"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visiblePosition = false;
                      editBxData('WORK_POSITION', WORK_POSITION);
                    "
                  />
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('Przelozony')">
              {{
                getUserInfo(0, [
                  "LAST_NAME",
                  "NAME",
                  { field: "WORK_POSITION", brackets: true },
                ])
              }}
            </a-descriptions-item>
            <a-descriptions-item :label="$t('LiczbaDni')">{{
              DniWRoku - UzywaneDni
            }}</a-descriptions-item>
          </a-descriptions>
        </div>
        <div id="contactData">
          <a-descriptions
            bordered
            :title="$t('Dane kontaktowe')"
            size="small"
            :column="1"
          >
            <a-descriptions-item :label="$t('EMAIL')">
              <a-row type="flex" v-if="!visibleEmail">
                <a-col style="flex: 1; padding-right: 5px">{{
                  userInfo[currentUserIdForEdit].EMAIL
                }}</a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleEmail = true;
                  EMAIL = userInfo[currentUserIdForEdit].EMAIL;
                  "></a-button>
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleEmail">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="userInfo[currentUserIdForEdit].EMAIL"
                    v-model="EMAIL"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleEmail = false;
                      editBxData('EMAIL', EMAIL);
                    "
                  />
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('UF_PHONE_INNER')">
              <a-row type="flex" v-if="!visibleT1">
                <a-col style="flex: 1; padding-right: 5px">{{
                  entityUser.UF_PHONE_INNER
                }}</a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleT1 = true;
                  UF_PHONE_INNER = entityUser.UF_PHONE_INNER;
                  "></a-button>
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleT1">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="entityUser.UF_PHONE_INNER"
                    v-model="UF_PHONE_INNER"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleT1 = false;
                      editData('UF_PHONE_INNER', UF_PHONE_INNER);
                    "
                    WORK_PHONE
                  />
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('PERSONAL_MOBILE')">
              <a-row type="flex" v-if="!visibleT2">
                <a-col style="flex: 1; padding-right: 5px">{{
                  userInfo[currentUserIdForEdit].PERSONAL_MOBILE
                }}</a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleT2 = true;
                  PERSONAL_MOBILE =
                    userInfo[currentUserIdForEdit].PERSONAL_MOBILE;
                  "></a-button>
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleT2">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="
                      userInfo[currentUserIdForEdit].PERSONAL_MOBILE
                    "
                    v-model="PERSONAL_MOBILE"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleT2 = false;
                      editBxData('PERSONAL_MOBILE', PERSONAL_MOBILE);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </a-col>
      <a-col
        :span="12"
        v-if="
          userInfo.length != 0 &&
          currentUserObj != '' &&
          (isAdmin ||
            userAccess.length != 0 ||
            currentUserObj.ID == userInfo[currentUserIdForEdit].ID)
        "
      >
        <div id="personalData">
          <a-descriptions
            bordered
            :title="$t('Dane personalne')"
            size="small"
            :column="1"
          >
            <a-descriptions-item :label="$t('SECOND_NAME')">
              <a-row type="flex" v-if="!visibleOtherImie">
                <a-col style="flex: 1; padding-right: 5px">{{
                  userInfo[currentUserIdForEdit].SECOND_NAME
                }}</a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleOtherImie = true;
                  SECOND_NAME = userInfo[currentUserIdForEdit].SECOND_NAME;
                  "></a-button>
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleOtherImie">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="userInfo[currentUserIdForEdit].SECOND_NAME"
                    v-model="SECOND_NAME"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleOtherImie = false;
                      editBxData('SECOND_NAME', SECOND_NAME);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('NazwiskoRodowe')">
              <a-row type="flex" v-if="!visibleOtherNazw">
                <a-col style="flex: 1; padding-right: 5px">{{
                  entityUser.NazwiskoRodowe
                }}</a-col>
                <a-col v-if="isAdmin">
                  <a-button
                    type="link"
                    icon="edit"
                    @click="
                      visibleOtherNazw = true;
                      NazwiskoRodowe = entityUser.NazwiskoRodowe;
                    "
                  ></a-button>
                </a-col>
              </a-row>
              <a-row type="flex" v-if="visibleOtherNazw">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="entityUser ? entityUser.NazwiskoRodowe : ''"
                    v-model="NazwiskoRodowe"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleOtherNazw = false;
                      editData('NazwiskoRodowe', NazwiskoRodowe);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('PERSONAL_CITY')">
              <a-row type="flex" v-if="!visibleBithPlace">
                <a-col style="flex: 1; padding-right: 5px">{{
                  userInfo[currentUserIdForEdit].PERSONAL_CITY
                }}</a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleBithPlace = true;
                  PERSONAL_CITY =
                    userInfo[currentUserIdForEdit].PERSONAL_CITY;
                  "></a-button>
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleBithPlace">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input
                    :default-value="
                      userInfo[currentUserIdForEdit].PERSONAL_CITY
                    "
                    v-model="PERSONAL_CITY"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleBithPlace = false;
                      editBxData('PERSONAL_CITY', PERSONAL_CITY);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('PERSONAL_BIRTHDAY')">
              <a-row type="flex" v-if="!visibleDatePlec">
                <a-col style="flex: 1; padding-right: 5px">
                  {{
                    userInfo[currentUserIdForEdit].PERSONAL_BIRTHDAY
                      ? moment(
                          userInfo[currentUserIdForEdit].PERSONAL_BIRTHDAY
                        ).format(dateFormat)
                      : ""
                  }}
                </a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visibleDatePlec = true;
                  PERSONAL_BIRTHDAY = userInfo[currentUserIdForEdit]
                    .PERSONAL_BIRTHDAY
                    ? moment(
                      userInfo[currentUserIdForEdit].PERSONAL_BIRTHDAY
                    )
                    : '';
                  "></a-button>
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visibleDatePlec">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-date-picker
                    style="width: 100%"
                    :format="dateFormat"
                    v-model="PERSONAL_BIRTHDAY"
                  />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleDatePlec = false;
                      editBxData(
                        'PERSONAL_BIRTHDAY',
                        moment(PERSONAL_BIRTHDAY).format(dateFormat)
                      );
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('PERSONAL_GENDER')">
              <a-row type="flex" v-if="!visiblePlec">
                <a-col style="flex: 1; padding-right: 5px">
                  {{
                    userInfo[currentUserIdForEdit].PERSONAL_GENDER == "M"
                      ? $t("he")
                      : userInfo[currentUserIdForEdit].PERSONAL_GENDER == "F"
                      ? $t("she")
                      : ""
                  }}
                </a-col>
                <!-- <a-col v-if="isAdmin">
                  <a-button type="link" icon="edit" @click="
                    visiblePlec = true;
                  PERSONAL_GENDER =
                    userInfo[currentUserIdForEdit].PERSONAL_GENDER;
                  "></a-button>
                </a-col> -->
              </a-row>
              <a-row type="flex" v-if="visiblePlec">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-select style="width: 100%" v-model="PERSONAL_GENDER">
                    <a-select-option
                      v-for="item in [
                        [$t('he'), 'M'],
                        [$t('she'), 'F'],
                      ]"
                      :key="item[1]"
                      :value="item[1]"
                      >{{ item[0] }}</a-select-option
                    >
                  </a-select>
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visiblePlec = false;
                      editBxData('PERSONAL_GENDER', PERSONAL_GENDER);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('PESEL')">
              <a-row type="flex" v-if="!visiblePESEL">
                <a-col style="flex: 1; padding-right: 5px">{{
                  entityUser.PESEL
                }}</a-col>
                <a-col v-if="isAdmin">
                  <a-button
                    type="link"
                    icon="edit"
                    @click="
                      visiblePESEL = true;
                      PESEL = entityUser.PESEL;
                    "
                  ></a-button>
                </a-col>
              </a-row>
              <a-row type="flex" v-if="visiblePESEL">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input v-model="PESEL" />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visiblePESEL = false;
                      editData('PESEL', PESEL);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('NIP')">
              <a-row type="flex" v-if="!visibleNIP">
                <a-col style="flex: 1; padding-right: 5px">{{
                  entityUser.NIP
                }}</a-col>
                <a-col v-if="isAdmin">
                  <a-button
                    type="link"
                    icon="edit"
                    @click="
                      visibleNIP = true;
                      NIP = entityUser.NIP;
                    "
                  ></a-button>
                </a-col>
              </a-row>
              <a-row type="flex" v-if="visibleNIP">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input v-model="NIP" />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleNIP = false;
                      editData('NIP', NIP);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('NrDoc')">
              <a-row type="flex" v-if="!visibleNrDoc">
                <a-col style="flex: 1; padding-right: 5px">{{
                  entityUser.NrDoc
                }}</a-col>
                <a-col v-if="isAdmin">
                  <a-button
                    type="link"
                    icon="edit"
                    @click="
                      visibleNrDoc = true;
                      NrDoc = entityUser.NrDoc;
                    "
                  ></a-button>
                </a-col>
              </a-row>
              <a-row type="flex" v-if="visibleNrDoc">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input v-model="NrDoc" />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleNrDoc = false;
                      editData('NrDoc', NrDoc);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('Skarbowy')">
              <a-row type="flex" v-if="!visibleSkarbowy">
                <a-col style="flex: 1; padding-right: 5px">{{
                  entityUser.Skarbowy
                }}</a-col>
                <a-col v-if="isAdmin">
                  <a-button
                    type="link"
                    icon="edit"
                    @click="
                      visibleSkarbowy = true;
                      Skarbowy = entityUser.Skarbowy;
                    "
                  ></a-button>
                </a-col>
              </a-row>
              <a-row type="flex" v-if="visibleSkarbowy">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-input v-model="Skarbowy" />
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleSkarbowy = false;
                      editData('Skarbowy', Skarbowy);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
            <a-descriptions-item :label="$t('Wyksztalcenie')">
              <a-row type="flex" v-if="!visibleWyksztalcenie">
                <a-col style="flex: 1; padding-right: 5px">
                  {{
                    entityUser.Wyksztalcenie ? $t(entityUser.Wyksztalcenie) : ""
                  }}
                </a-col>
                <a-col v-if="isAdmin">
                  <a-button
                    type="link"
                    icon="edit"
                    @click="
                      visibleWyksztalcenie = true;
                      Wyksztalcenie = entityUser.Wyksztalcenie;
                    "
                  ></a-button>
                </a-col>
              </a-row>
              <a-row type="flex" v-if="visibleWyksztalcenie">
                <a-col style="flex: 1; padding-right: 5px">
                  <a-select style="width: 100%" v-model="Wyksztalcenie">
                    <a-select-option value="Podstawowe">
                      {{ $t("Podstawowe") }}
                    </a-select-option>
                    <a-select-option value="Srednie zawodowe">
                      {{ $t("Srednie zawodowe") }}
                    </a-select-option>
                    <a-select-option value="Srednie ogolnoksztalcace">
                      {{ $t("Srednie ogolnoksztalcace") }}
                    </a-select-option>
                    <a-select-option value="Policealne">
                      {{ $t("Policealne") }}
                    </a-select-option>
                    <a-select-option value="Wyzsze licencjackie">
                      {{ $t("Wyzsze licencjackie") }}
                    </a-select-option>
                    <a-select-option value="Wyzsze inzynierskie">
                      {{ $t("Wyzsze inzynierskie") }}
                    </a-select-option>
                    <a-select-option value="Wyzsze magisterskei">
                      {{ $t("Wyzsze magisterskei") }}
                    </a-select-option>
                    <a-select-option value="Studia podyplomowe">
                      {{ $t("Studia podyplomowe") }}
                    </a-select-option>
                    <a-select-option value="Studia MBA">
                      {{ $t("Studia MBA") }}
                    </a-select-option>
                    <a-select-option value="Studia doktoranckie">
                      {{ $t("Studia doktoranckie") }}
                    </a-select-option>
                    <a-select-option value="Stopien naukowy">
                      {{ $t("Stopien naukowy") }}
                    </a-select-option>
                  </a-select>
                </a-col>
                <a-col>
                  <a-button
                    type="link"
                    icon="check"
                    @click="
                      visibleWyksztalcenie = false;
                      editData('Wyksztalcenie', Wyksztalcenie);
                    "
                  ></a-button>
                </a-col>
              </a-row>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from "moment";
import { updateAuth, sendEditBxData, sendEditData } from "../requestFunc";

export default {
  props: [
    "userInfo",
    "currentUserObj",
    "currentUserIdForEdit",
    "departments",
    "entityUser",
    "UzywaneDni",
    "DniWRoku",
    "DniNieobecnosci",
    "companies",
    "allcompanies",
    "isAdmin",
    "userAccess",
    "daysLeft",
    "currentBxUserDepartments",
    "infoo_currentUsersInDepartments",
  ],
  data() {
    return {
      dateFormat: "YYYY-MM-DD",
      dreamVacationDate: [],
      visibleIdentificator: false,
      Identificator: "",
      visiblePESEL: false,
      PESEL: "",
      visibleNIP: false,
      NIP: "",
      visibleNrDoc: false,
      NrDoc: "",
      visibleSkarbowy: false,
      Skarbowy: "",
      visibleWyksztalcenie: false,
      Wyksztalcenie: "",
      visibleImie: false,
      NAME: "",
      visibleNazw: false,
      LAST_NAME: "",
      visibleEmail: false,
      EMAIL: "",
      NazwiskoRodowe: "",
      visibleT1: false,
      UF_PHONE_INNER: "",
      companyTitle: "",
      visibleT2: false,
      PERSONAL_MOBILE: "",
      visibleOtherImie: false,
      SECOND_NAME: "",
      visibleOtherNazw: false,
      visibleBithPlace: false,
      PERSONAL_CITY: "",
      visibleDatePlec: false,
      PERSONAL_BIRTHDAY: "",
      visiblePlec: false,
      PERSONAL_GENDER: "",
      WORK_POSITION: "",
      visiblePosition: false,
      UF_DEPARTMENT: [],
      visibleDepartment: false,
      Wyksztalcenies: [
        "Podstawowe",
        "Średnie zawodowe",
        "Średnie ogólnokształcące",
        "Policealne",
        "Wyższe licencjackie",
        "Wyższe inżynierskie",
        "Wyższe magisterskei",
        "Studia podyplomowe",
        "Studia MBA",
        "Studia doktoranckie",
        "Stopień naukowy",
      ],
      userDomain: updateAuth().domain,
      defaultFirstUser: "",
      userInfoCopy: null,
      searchUserInput: "",
    };
  },
  filters: {
    genderFilter(value) {
      if (value == "M") {
        return "Mężczyzna";
      } else if (value == "W") {
        return "Kobieta";
      } else return "";
    },
  },
  computed: {
    filterUserList() {
      return this.userInfo
        .map((el, index) => ({ ...el, index }))
        .filter((el) => {
          return (
            (el.LAST_NAME + " " + el.NAME)
              .toLowerCase()
              .indexOf(this.searchUserInput.toLowerCase()) > -1
          );
        });
    },
  },
  methods: {
    moment,
    resetFields() {
      this.visiblePESEL = false;
      this.visibleNIP = false;
      this.visibleNrDoc = false;
      this.visibleSkarbowy = false;
      this.visibleWyksztalcenie = false;
      this.visibleImie = false;
      this.visibleNazw = false;
      this.visibleEmail = false;
      this.visibleT1 = false;
      this.visibleT2 = false;
      this.visibleOtherImie = false;
      this.visibleOtherNazw = false;
      this.visibleBithPlace = false;
      this.visibleDatePlec = false;
      this.visiblePlec = false;
      this.visiblePosition = false;
      this.visibleDepartment = false;
    },
    handleChangeDepartments(value) {
      this.UF_DEPARTMENT = value.map((el) => {
        let a = 0;
        this.departments.forEach((item) => {
          if (item.NAME == el) a = item.ID;
        });
        return a;
      });
    },

    checkBoss(dep_index) {
      let dep = this.getDepartmentInfo(dep_index);
      if (dep.UF_HEAD == this.userInfo[this.currentUserIdForEdit].ID)
        return false;
      else return true;
    },

    getUserInfo(dep_index, keys = []) {
      if (this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT.length == 1) {
        let dep = this.getDepartmentInfo(0);
        if (dep?.UF_HEAD == this.userInfo[this.currentUserIdForEdit].ID) return;
        let user = dep
          ? this.userInfo.find((item) => dep.UF_HEAD == item.ID)
          : false;
        let res = "";
        if (user) {
          for (let i of keys) {
            if (typeof i == "object") {
              if (i.brackets && user[i.field]) res += ` (${user[i.field]})`;
            } else {
              res += ` ${user[i]}`;
            }
          }
        }
        if (res == "") res = "-";

        return res;
      } else if (
        this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT.length > 1
      ) {
        let dep2 = this.departments[0];

        let user2 = dep2
          ? this.userInfo.find((item) => dep2.UF_HEAD == item.ID)
          : false;
        let res2 = "";
        if (user2) {
          for (let i of keys) {
            if (typeof i == "object") {
              if (i.brackets && user2[i.field]) res2 += ` (${user2[i.field]})`;
            } else {
              res2 += ` ${user2[i]}`;
            }
          }
        }
        if (res2 == "") res2 = "-";

        return res2;
      }
    },
    // getUserInfo(dep_index, keys = []) {
    //   let dep = this.getDepartmentInfo(dep_index);
    //   if (dep.UF_HEAD == this.userInfo[this.currentUserIdForEdit].ID) return;
    //   let user = dep
    //     ? this.userInfo.find((item) => dep.UF_HEAD == item.ID)
    //     : false;
    //   let res = "";
    //   if (user) {
    //     for (let i of keys) {
    //       if (typeof i == "object") {
    //         if (i.brackets && user[i.field]) res += ` (${user[i.field]})`;
    //       } else {
    //         res += ` ${user[i]}`;
    //       }
    //     }
    //   }
    //   if (res == "") res = "-";

    //   //
    //   let dep2 = this.departments[0];

    //   if (dep.ID != dep2.ID) {
    //     let user2 = dep2
    //       ? this.userInfo.find((item) => dep2.UF_HEAD == item.ID)
    //       : false;
    //     let res2 = "";
    //     if (user2) {
    //       for (let i of keys) {
    //         if (typeof i == "object") {
    //           if (i.brackets && user2[i.field]) res2 += ` (${user2[i.field]})`;
    //         } else {
    //           res2 += ` ${user2[i]}`;
    //         }
    //       }
    //     }
    //     if (res2 == "") res2 = "-";
    //     res += ` (${res2})`;
    //   }
    //   //

    //   return res;
    // },
    getDepartmentInfo(dep_index, key) {
      if (this.departments) {
        let dep = this.departments.find(
          (el) =>
            el.ID ==
            this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT[dep_index]
        );
        if (dep) return key ? dep[key] : dep;
        return dep;
      }
    },
    seoDepartmentID() {
      let d = this.departments.filter((el) => {
        if (
          this.userInfo[this.currentUserIdForEdit].UF_DEPARTMENT[0] == el.ID
        ) {
          return el;
        }
      })[0].UF_HEAD;
      return d;
    },
    searchUser(value) {
      this.searchUserInput = value;
    },
    changeCurrentUserIdForEdit(index) {
      let key = this.userInfo.findIndex((el) => el.ID == index);
      this.searchUserInput = "";
      this.resetFields();
      this.$emit("changecurrentUserIdForEdit", key);
      this.$emit("loadSelectedCommonData", 1);
    },
    async editBxData(field, data) {
      if (
        data !=
        (this.userInfo[this.currentUserIdForEdit][field] ||
          this.entityUser[field])
      ) {
        sendEditBxData({
          user_id: this.userInfo[this.currentUserIdForEdit].ID,
          field,
          data: {
            old:
              this.userInfo[this.currentUserIdForEdit][field] ||
              this.entityUser[field],
            new: data,
          },
        }).done((res) => {
          let result = JSON.parse(res);
          this.$emit("setNewUserBxInfo", field, result.upd);
        });
        // const response = await fetch(url, {
        //   method: "POST",
        //   body: generateFormData({
        //     run: "editBxData",
        //   }),
        // });

        // const results = await response.json();
        // const newUserInfo = results.upd[0];
      }
    },
    async editData(field, data) {
      // if (field == "PESEL") {
      //   if (data.length != 11 && data.length != 0) {
      //     this.$message.warning(this.$t("warning message pesel"));
      //     return;
      //   }
      // } else if (field == "NIP") {
      //   if (
      //     (data.length != 10 && data.length != 0) ||
      //     Number.isInteger(+data) === false
      //   ) {
      //     this.$message.warning(this.$t("warning message nip"));
      //     return;
      //   }
      // }
      if (
        data !=
        (this.userInfo[this.currentUserIdForEdit][field] ||
          this.entityUser[field])
      ) {
        sendEditData({
          user_id: this.userInfo[this.currentUserIdForEdit].ID,
          field: field,
          data: {
            old:
              this.userInfo[this.currentUserIdForEdit][field] ||
              this.entityUser[field],
            new: data,
          },
        }).done((res) => {
          let result = JSON.parse(res);
          this.$emit("setNewUserInfo", field, result.upd);
        });
      }
    },
  },
  mounted() {
    console.log(this.entityUser, "userInfo");
    /* let comp =
      this.entityUser.NazwaFirmy && this.entityUser.NazwaFirmy != "undefined"
        ? this.allcompanies[this.entityUser.NazwaFirmy]
        : "";
    this.companyTitle = comp && comp.TITLE ? comp.TITLE : "";*/
    BX24.fitWindow();
  },
  created() {},
};
</script>

<style scoped>
.itemsInfo,
.itemsInfoTitle {
  display: block;
  width: 50%;
  text-align: left;
  padding-left: 5px;
  margin: 0;
  line-height: 2.3;
}

.itemsInfo {
  border-left: 1px solid lightgray;
  font-weight: 200;
}

.itemsInfoTitle,
.headerListData {
  font-weight: 400;
}

#chooseEmployee h2 {
  font-weight: 500;
}

#mainCommonDataWrapper {
  font-weight: 200;
}

.itemsInfo h2 {
  margin: 0;
}

#commonData .ant-list-item,
#personalData .ant-list-item,
#contactData .ant-list-item {
  padding: 0;
}

.ant-btn-link {
  color: #1890ff !important;
}

#commonData {
  margin-bottom: 10px;
}
</style>
